import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import { Layout } from './components/Layout'
import { LoadingSpinner } from './components/LoadingSpinner'

// 页面组件 - 懒加载
const LoginPage = React.lazy(() => import('./pages/auth/LoginPage'))
const RegisterPage = React.lazy(() => import('./pages/auth/RegisterPage'))
const DashboardPage = React.lazy(() => import('./pages/DashboardPage'))
const TeachersPage = React.lazy(() => import('./pages/TeachersPage'))
const BookingPage = React.lazy(() => import('./pages/BookingPage'))
const MyCoursesPage = React.lazy(() => import('./pages/MyCoursesPage'))
const MaterialsPage = React.lazy(() => import('./pages/MaterialsPage'))
const SoftwareToolsPage = React.lazy(() => import('./pages/SoftwareToolsPage'))
const MessagesPage = React.lazy(() => import('./pages/MessagesPage'))
const AccountPage = React.lazy(() => import('./pages/AccountPage'))
const ReportsPage = React.lazy(() => import('./pages/ReportsPage'))
const ProfilePage = React.lazy(() => import('./pages/ProfilePage'))
const BookingsPage = React.lazy(() => import('./pages/BookingsPage'))
const ComplaintSubmitPage = React.lazy(() => import('./pages/ComplaintSubmitPage'))
const SettingsPage = React.lazy(() => import('./pages/SettingsPage'))
const HelpPage = React.lazy(() => import('./pages/HelpPage'))
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage'))

function App() {
  const { isAuthenticated, isLoading, user } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner className="w-12 h-12 mx-auto mb-4" />
          <p className="text-gray-600">加载中...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="layout-container">
      <React.Suspense fallback={
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <LoadingSpinner className="w-8 h-8" />
        </div>
      }>
        <Routes>
          {/* 认证路由 */}
          {!isAuthenticated ? (
            <>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </>
          ) : (
            <>
              {/* 已认证路由 - 使用新的Layout组件 */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="teachers" element={<TeachersPage />} />
                <Route path="booking" element={<BookingPage />} />
                <Route path="my-courses" element={<MyCoursesPage />} />
                <Route path="materials" element={<MaterialsPage />} />
                <Route path="software-tools" element={<SoftwareToolsPage />} />
                <Route path="messages" element={<MessagesPage />} />
                <Route path="account" element={<AccountPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route path="bookings" element={<BookingsPage />} />
                <Route path="complaints/new" element={<ComplaintSubmitPage />} />
                <Route path="profile/settings" element={<SettingsPage />} />
                <Route path="help" element={<HelpPage />} />
              </Route>
              {/* 已登录用户访问登录/注册页面时重定向到仪表板 */}
              <Route path="/login" element={<Navigate to="/dashboard" replace />} />
              <Route path="/register" element={<Navigate to="/dashboard" replace />} />
              {/* 404 页面 */}
              <Route path="*" element={<NotFoundPage />} />
            </>
          )}
        </Routes>
      </React.Suspense>
    </div>
  )
}

export default App
